import { isFeatureFlagForced } from '@/app/lib/featureFlags';

// Read from NEXT_PUBLIC_FORCED_FEATURE_FLAGS at build time: the GrowthBook provider is not mounted on the guide pages.
export const GUIDE_CHAT_FEATURE_FLAG = 'guide_chat';

export const isGuideChatSwitchedOn = (): boolean => isFeatureFlagForced(GUIDE_CHAT_FEATURE_FLAG);
